import { DotsVertical } from '~/ui/assets/icons';
import { MenuOptions, OptionProps } from '~/components';
import React from 'react';
import { useTheme } from 'styled-components';

export function cellToActions(options: OptionProps[], disabled?: boolean) {
  const theme = useTheme();

  return function ActionsCell() {
    return (
      <MenuOptions options={options} placement="bottomRight" disabled={disabled}>
        <DotsVertical color={theme.colors.brand.primary} width={16} height={16} />
      </MenuOptions>
    );
  };
}
